<template>
    <div class="card-deal-params-block">
        <el-row v-if="canViewField('delivery_date') && isValueVisible(delivery_date, 'delivery_date')">
            <el-col :span="10">
                <span class="gray">
                    Дата доставки
                </span>
            </el-col>
            <el-col :span="14">
                {{ delivery_date }}
            </el-col>
        </el-row>
        <el-row v-if="canViewField('installation_date') && isValueVisible(installation_date, 'installation_date')">
            <el-col :span="10">
                <span class="gray">
                    Дата монтажа
                </span>
            </el-col>
            <el-col :span="14">
                <template v-if="editMode && canEditField( 'installation_date')">
                    <el-date-picker
                        v-model="installation_date"
                        type="date"
                        placeholder="дд.мм.гггг"
                        clearable
                        format="dd.MM.yyyy"
                        value-format="dd.MM.yyyy"
                        :picker-options="pickerOptions"
                        :title="hasInstallLimitError ? installLimitErrorText : installTitle"
                        size="mini"
                        class="w100"
                        :class="hasInstallLimitError ? 'red' : ''"
                    />
                    <div class="field-error" v-if="errors.installation_date" v-text="errors.installation_date[0]"></div>
                </template>
                <template v-else>
                    {{ installation_date }}
                </template>
            </el-col>
        </el-row>
        <el-row v-if="canViewField('installation_user_id') && isValueVisible(installation_user_id, 'installation_user_id')">
            <el-col :span="10">
                <span class="gray">
                    Монтажная бригада
                </span>
            </el-col>
            <el-col :span="14">
                <template v-if="editMode && canEditField( 'installation_user_id')">
                    <el-select
                        v-model="installation_user_id"
                        placement="bottom"
                        popper-class="popper-dropdown"
                        autocomplete
                        filterable
                        clearable
                        placeholder="Монтажная бригада"
                        size="mini"
                    >
                        <el-option v-for="item in installerList" :key="item.id" :label="item.name" :value="item.id" :class="isFiredEmployerClass(item.date_fired)" />
                    </el-select>
                    <div class="field-error" v-if="errors.installation_user_id" v-text="errors.installation_user_id[0]"></div>
                </template>
                <template v-else>
                    <span class="orange pointer" @click="goCard(installation_user_id)">
                        {{ installationUserName }}
                    </span>
                </template>
            </el-col>
        </el-row>
        <el-row v-if="canViewField('square_m2') && isValueVisible(square_m2, 'square_m2')">
            <el-col :span="10">
                <span class="gray">
                    Квадратура, м2
                </span>
            </el-col>
            <el-col :span="14">
                {{ square_m2 }}
            </el-col>
        </el-row>
        <el-row v-if="canViewField( 'installer_balance', statusId) && isValueVisible(installer_balance, 'installer_balance')">
            <el-col :span="10">
                <span class="gray">
                    Остаток по монтажу, руб
                </span>
            </el-col>
            <el-col :span="14">
                {{ installer_balance | formatFinance }}
            </el-col>
        </el-row>
        <el-row v-if="canViewField('installers_salary', statusId) && isValueVisible(installers_salary, 'installers_salary')">
            <el-col :span="10">
                <span class="gray">
                    ЗП монтажников, руб.
                </span>
            </el-col>
            <el-col :span="14">
                <template v-if="editMode && canEditField( 'installers_salary', statusId)">
                    <auto-numeric
                        v-model="installers_salary"
                        :options="numericOptions"
                        class="autonumeric"
                    />
                    <div class="field-error" v-if="errors.installers_salary" v-text="errors.installers_salary[0]"></div>
                </template>
                <template v-else>
                    {{ installers_salary | formatFinance }}
                </template>
            </el-col>
        </el-row>
        <el-row v-if="canViewField( 'installers_debt', statusId) && isValueVisible(installers_debt, 'installers_debt')">
            <el-col :span="10">
                <span class="gray">
                    Долг монтажников, руб
                </span>
            </el-col>
            <el-col :span="14">
                {{ installers_debt | formatFinance }}
            </el-col>
        </el-row>
        <el-row v-if="canViewField('additional_work') && isValueVisible(additional_work, 'additional_work')">
            <el-col :span="10">
                <span class="gray">
                    Доп. работы, руб
                </span>
            </el-col>
            <el-col :span="14">
                <template v-if="editMode && canEditField( 'additional_work')">
                    <auto-numeric
                        v-model="additional_work"
                        :options="numericOptions"
                        class="autonumeric"
                    />
                    <div class="field-error" v-if="errors.additional_work" v-text="errors.additional_work[0]"></div>
                </template>
                <template v-else>
                    {{ additional_work | formatFinance }}
                </template>
            </el-col>
        </el-row>
        <el-row v-if="canViewField('installation_photo') && isValueVisible(installation_photo, 'installation_photo')">
            <el-col :span="editMode ? 8: 10">
                <span class="gray">
                    Фото объекта
                </span>
            </el-col>
            <el-col :span="2" v-if="editMode && canEditField( 'installation_photo')">
                <el-upload
                    action=""
                    :auto-upload="false"
                    :on-change="handleInstallationPhotoChange"
                    :on-exceed="handleExceed"
                    :limit="10"
                    :file-list="uploadInstallationPhotoFileList"
                    :show-file-list="false"
                    multiple
                    accept="image/*"
                >
                    <font-awesome-icon slot="trigger" icon="paperclip" class="orange pointer" />
                </el-upload>
            </el-col>
            <el-col :span="14">
                <template v-if="editMode && canEditField( 'installation_photo')">
                    <el-tag
                        v-for="file in uploadInstallationPhotoFileList"
                        :key="file.name"
                        closable
                        :type="''"
                        @close="handleInstallationPhotoClose(file)"
                        @click.native="handleInstallationPhotoTagClick(file)"
                        class="pointer"
                        size="mini"
                        :disable-transitions="true"
                    >
                        {{ cutString(file.name) }}
                    </el-tag>
                    <div class="field-error" v-if="errors.installation_photo" v-text="errors.installation_photo[0]"></div>
                </template>
                <template v-else>
                    <el-tag
                        v-for="file in installation_photo"
                        :key="file.id"
                        :type="''"
                        size="mini"
                        class="pointer"
                        @click.native="handleInstallationPhotoTagClick(file)"
                        :disable-transitions="true"
                    >
                        {{ cutString(file.name) }}
                    </el-tag>
                </template>
            </el-col>
        </el-row>
        <el-row v-if="canViewField('installation_act_photo') && isValueVisible(installation_act_photo, 'installation_act_photo')">
            <el-col :span="editMode ? 8: 10">
                <span class="gray">
                    Фото акта выполненных работ
                </span>
            </el-col>
            <el-col :span="2" v-if="editMode && canEditField( 'installation_act_photo')">
                <el-upload
                    action=""
                    :auto-upload="false"
                    :on-change="handleInstallationActPhotoChange"
                    :on-exceed="handleExceed"
                    :limit="10"
                    :file-list="uploadInstallationPhotoFileList"
                    :show-file-list="false"
                    multiple
                    accept="image/*"
                >
                    <font-awesome-icon slot="trigger" icon="paperclip" class="orange pointer" />
                </el-upload>
            </el-col>
            <el-col :span="14">
                <template v-if="editMode && canEditField( 'installation_act_photo')">
                    <el-tag
                        v-for="file in uploadInstallationActPhotoFileList"
                        :key="file.name"
                        closable
                        :type="''"
                        @close="handleInstallationActPhotoClose(file)"
                        @click.native="handleInstallationActPhotoTagClick(file)"
                        class="pointer"
                        size="mini"
                        :disable-transitions="true"
                    >
                        {{ cutString(file.name) }}
                    </el-tag>
                    <div class="field-error" v-if="errors.installation_act_photo" v-text="errors.installation_act_photo[0]"></div>
                </template>
                <template v-else>
                    <el-tag
                        v-for="file in installation_act_photo"
                        :key="file.id"
                        :type="''"
                        size="mini"
                        class="pointer"
                        @click.native="handleInstallationActPhotoTagClick(file)"
                        :disable-transitions="true"
                    >
                        {{ cutString(file.name) }}
                    </el-tag>
                </template>
            </el-col>
        </el-row>
        <el-row v-if="canViewField('measure_photo') && isValueVisible(measure_photo, null, false)">
            <el-col :span="10">
                <span class="gray">
                    Лист замера
                </span>
            </el-col>
            <el-col :span="14">
                <template>
                    <el-tag
                        v-for="file in measure_photo"
                        :key="file.id"
                        :type="''"
                        size="mini"
                        class="pointer"
                        @click.native="handleTagClick(file)"
                        :disable-transitions="true"
                    >
                        {{ cutString(file.name) }}
                    </el-tag>
                </template>
            </el-col>
        </el-row>
        <el-row v-if="canViewField('contract_comment') && isValueVisible(contract_comment, null, false)">
            <el-col :span="10">
                <span class="gray">
                    Комментарий
                </span>
            </el-col>
            <el-col :span="14">
                <div v-format-text="contract_comment"></div>
            </el-col>
        </el-row>
        <el-row v-if="canViewField( 'installation_done') && isValueVisible(installation_done, 'installation_done')">
            <el-col :span="10">
                <span class="gray">
                    Монтаж выполнен
                </span>
            </el-col>
            <el-col :span="1" v-if="editMode && canEditField( 'installation_done')">
                <el-checkbox v-model="installation_done" />
            </el-col>
            <el-col :span="1" v-else>
                <font-awesome-icon icon="check-square" class="orange" v-if="installation_done" />
                <font-awesome-icon :icon="['far', 'square']" class="orange" v-else />
            </el-col>
        </el-row>
    </div>
</template>

<script>
import { cardMixin } from '@/mixins/card';
import FileSaver from 'file-saver';
import { pickerOptions } from '@/common/pickerOptions';

export default {
    name: 'Installation',
    mixins: [
        cardMixin
    ],
    data() {
        return {
            uploadInstallationPhotoFileList: [],
            uploadInstallationActPhotoFileList: [],
            pickerOptions,
            hasInstallLimitError: 0,
            installLimitErrorText: 'Превышен максимальный лимит монтажей за день. Проверьте настройки',
            installTitle: ''
        };
    },
    computed: {
        installationUserName() {
            return this.$store.state.deals.current.installation_user ? this.$store.state.deals.current.installation_user.full_name : '';
        },
        installerList() {
            if (this.canViewDateFired) {
                return this.filterFiredEmployers(this.$store.state.references.installers);
            }
            return this.$store.state.references.installers;
        },
        measure_photo() {
            return this.$store.state.deals.current.measure_photo;
        },
        installation_date: {
            get() {
                return this.$store.state.deals.current.installation_date;
            },
            set(value) {
                this.loading = true;
                this.$store.dispatch('deals/getInstallationCountByDate', {
                    date: value
                }).then(response => {
                    const installCount = response.count + 1;
                    console.log('installCount ' + installCount);
                    console.log('settings ' + this.settings.install_limit_per_day);
                    if (this.settings && Object.prototype.hasOwnProperty.call(this.settings, 'install_limit_per_day')) {
                        if (installCount > this.settings.install_limit_per_day) {
                            this.hasInstallLimitError = 1;
                            this.$message({
                                showClose: true,
                                message: this.installLimitErrorText + ' (' + this.settings.install_limit_per_day + 'монтажей/день' + ')',
                                type: 'error',
                                duration: 5000,
                                customClass: this.alertClass()
                            });
                        } else {
                            this.hasInstallLimitError = 0;
                            this.$store.commit('deals/setCurrentField', { field: 'installation_date', value });
                        }
                    }
                }).catch(error => {
                    console.log(error);
                }).finally(() => {
                    this.loading = false;
                });
            }
        },
        installation_user_id: {
            get() {
                return this.$store.state.deals.current.installation_user_id;
            },
            set(value) {
                this.$store.commit('deals/setCurrentField', { field: 'installation_user_id', value });
            }
        },
        installers_salary: {
            get() {
                return this.$store.state.deals.current.installers_salary;
            },
            set(value) {
                this.$store.commit('deals/setCurrentField', { field: 'installers_salary', value });
            }
        },
        installers_debt: {
            get() {
                return this.$store.state.deals.current.installers_debt;
            },
            set(value) {
                this.$store.commit('deals/setCurrentField', { field: 'installers_debt', value });
            }
        },
        additional_work: {
            get() {
                return this.$store.state.deals.current.additional_work;
            },
            set(value) {
                this.$store.commit('deals/setCurrentField', { field: 'additional_work', value });
            }
        },
        installation_photo: {
            get() {
                return this.$store.state.deals.current.installation_photo;
            },
            set(value) {
                this.$store.commit('deals/setCurrentField', { field: 'installation_photo', value });
            }
        },
        installation_act_photo: {
            get() {
                return this.$store.state.deals.current.installation_act_photo;
            },
            set(value) {
                this.$store.commit('deals/setCurrentField', { field: 'installation_act_photo', value });
            }
        },
        contract_comment: {
            get() {
                return this.$store.state.deals.current.contract_comment;
            },
            set(value) {
                this.$store.commit('deals/setCurrentField', { field: 'contract_comment', value });
            }
        },
        installation_done: {
            get() {
                return this.$store.state.deals.current.installation_done;
            },
            set(value) {
                this.$store.commit('deals/setCurrentField', { field: 'installation_done', value });
            }
        },
        square_m2() {
            return this.$store.state.deals.current.square_m2;
        },
        installer_balance() {
            return this.$store.state.deals.current.installer_balance;
        },
        delivery_date() {
            return this.$store.state.deals.current.delivery_date;
        },
        settings() {
            return this.$store.state.auth.settings;
        }
    },
    methods: {
        goCard(id) {
            this.$router.push({ name: 'employer-card', params: { id } });
        },
        handleExceed() {
            this.$message({
                showClose: true,
                message: 'Внимание, лимит 10 файлов!',
                type: 'warning',
                duration: 5000,
                customClass: this.alertClass()
            });
        },
        handleInstallationPhotoChange(file, fileList) {
            this.uploadInstallationPhotoFileList = fileList;
            this.$store.commit('deals/setCurrentField', { field: 'installation_photo', value: [...this.uploadInstallationPhotoFileList] });
        },
        handleInstallationPhotoClose(tag) {
            this.uploadInstallationPhotoFileList.splice(this.uploadInstallationPhotoFileList.indexOf(tag), 1);
            this.$store.commit('deals/setCurrentField', { field: 'installation_photo', value: [...this.uploadInstallationPhotoFileList] });
        },
        handleInstallationPhotoTagClick(tag) {
            if (!tag.id) {
                return;
            }
            this.$store.dispatch('deals/getPhoto', { block: 'installation', id: tag.id })
                .then(response => {
                    FileSaver(new Blob([response.data], { type: tag.type }), tag.name);
                })
                .catch(error => {
                    console.log(error);
                });
        },
        handleInstallationActPhotoChange(file, fileList) {
            this.uploadInstallationActPhotoFileList = fileList;
            this.$store.commit('deals/setCurrentField', { field: 'installation_act_photo', value: [...this.uploadInstallationActPhotoFileList] });
        },
        handleInstallationActPhotoClose(tag) {
            this.uploadInstallationActPhotoFileList.splice(this.uploadInstallationActPhotoFileList.indexOf(tag), 1);
            this.$store.commit('deals/setCurrentField', { field: 'installation_act_photo', value: [...this.uploadInstallationActPhotoFileList] });
        },
        handleInstallationActPhotoTagClick(tag) {
            if (!tag.id) {
                return;
            }
            this.$store.dispatch('deals/getPhoto', { block: 'installation_act', id: tag.id })
                .then(response => {
                    FileSaver(new Blob([response.data], { type: tag.type }), tag.name);
                })
                .catch(error => {
                    console.log(error);
                });
        }
    },
    watch: {
        installation_photo: {
            handler(value) {
                if (this.uploadInstallationPhotoFileList && value.length) {
                    this.uploadInstallationPhotoFileList = [...value];
                }
            },
            deep: true
        },
        installation_act_photo: {
            handler(value) {
                if (this.uploadInstallationActPhotoFileList && value.length) {
                    this.uploadInstallationActPhotoFileList = [...value];
                }
            },
            deep: true
        }
    },
    mounted() {
        if (this.uploadInstallationPhotoFileList && this.uploadInstallationPhotoFileList.length === 0 && this.installation_photo.length) {
            this.uploadInstallationPhotoFileList = [...this.installation_photo];
        }
        if (this.uploadInstallationActPhotoFileList && this.uploadInstallationActPhotoFileList.length === 0 && this.installation_act_photo.length) {
            this.uploadInstallationActPhotoFileList = [...this.installation_act_photo];
        }
    }
};
</script>
